// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelDisabled-Layout_cls1__YOwNL","cls2":"PaymentChannelDisabled-Layout_cls2__RebQU PaymentChannelDisabled-Layout_cls1__YOwNL"};